import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Приключенческий туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Вид туризма, связанный с организвцией нестандартных туров в экзотические и экологически чистые
                        природные резервации, с необычными нетрадиционными транспортными средства.</p>
                    <p>К приключенческому туризму относятся походные экспедиции, сафпри-туры (охота, рыбалка, фотоохота
                        и др.), кругосветное плавание (яхтинг), сплав по горным рекам (рафтинг), путешествие пешком в
                        горах (треккинг).</p>
                </div>
            </div>
        </>
    );
}